import { Select, MenuItem } from '@mui/material';
import { searchTypeEnumToString } from '@utils/searchTypeEnumToString';

interface SearchCategoriesProps {
  categoryValues: any[];
  searchType: string;
  setSearchType: React.Dispatch<React.SetStateAction<string>>;
}

const SearchCategories = ({
  categoryValues,
  searchType,
  setSearchType
}: SearchCategoriesProps) => {
  return (
    <Select
      sx={{
        height: 40
      }}
      value={searchType}
      onChange={(event) => {
        const { value } = event.target;
        setSearchType(value);
      }}
    >
      {categoryValues.map((value) => {
        return (
          <MenuItem key={value} value={value}>
            <em>{searchTypeEnumToString(value)}</em>
          </MenuItem>
        );
      })}
    </Select>
  );
};

export default SearchCategories;
